import { useCurrentStep } from './useCurrentStep';
export const useSearchAndPrefillExperiment = () => {
  const {
    currentStep
  } = useCurrentStep();
  const searchAndPrefillHelperText = `views.${currentStep}.help`;
  return {
    searchAndPrefillHelperText
  };
};